import { render, staticRenderFns } from "./studentFeatured.vue?vue&type=template&id=79656dca&scoped=true&"
import script from "./studentFeatured.js?vue&type=script&lang=js&"
export * from "./studentFeatured.js?vue&type=script&lang=js&"
import style0 from "./studentFeatured.vue?vue&type=style&index=0&id=79656dca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79656dca",
  null
  
)

export default component.exports